import React from 'react';
import Loader, { LoaderProps } from './Loader';
import { StyleProp, View, ViewStyle } from 'react-native';
import Text from '../Text';

export type LoadingContentOwnProps = {
    style?: StyleProp<ViewStyle>;
    message?: string;
};

export type LoadingContentProps = LoadingContentOwnProps & LoaderProps;

const LoadingContent: React.FC<LoadingContentProps> = ({ style, message, ...toPass }) => {
    return (
        <View
            style={[
                { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' },
                style,
            ]}
        >
            <Loader {...toPass} />
            {message ? (
                <Text variant="caption-2" color="Gray-Text" alignText="center" style={{ marginTop: 10 }}>
                    {message}
                </Text>
            ) : null}
        </View>
    );
};

export default React.memo(LoadingContent);
